import { getXCLEARCorrelationInfo } from '@api/utils'

export const baseLookup = async (
  key: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<{ label: string; value: any }[]> => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_LOOKUP_API_ENDPOINT}/lookup?categories=${key}`,
    {
      headers: {
        'X-CLEAR-CorrelationInfo': getXCLEARCorrelationInfo(),
      },
    }
  )

  const data = await response.json()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return data[0].values.map((x: any) => ({
    label: x.text,
    value: x.key,
  }))
}
